import './DeparturesFilters.scss';

import { useSelector } from "react-redux";

import { useGetFilters } from "../../hooks/useGetFilters";
import { useGetFilterWithOptions } from "../../hooks/useGetFilterWithOptions";

import { FilterField } from "../../common-components/FilterField/FilterField";

const DeparturesFilters = () => {
    const componentId = "departures";
    const token = useSelector((state) => state.auth.token);
    const { filters: rawFilters } = useGetFilters();
    const { filters } = useGetFilterWithOptions(rawFilters, token);

    console.log("Hydrated Filters", filters);

    if (!filters) {
        return null
    }

    return (
        <div className={"departures-filters"}>
            <div className={"departures-filters_container"}>
                <div className={"departures-filters_items"}>
                    {Object.entries(filters).map(([filterKey, filter]) => (
                        <FilterField
                            name={filter.name}
                            key={filter.key}
                            label={filter.label || filter.alias}
                            type={filter.type}
                            propertyLabel={filter.alias || filter.label}
                            filterKey={filter.filterKey}
                            componentId={componentId}
                            filterStructure={filter}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default DeparturesFilters;